const postCompaniesStr = {
  toastr: 'Added company',
  toastr1: ' has been successfully added',
  toastrError: 'Company already registered',
  toastrError1: 'Enter this CNPJ or Name already registered'
};

export default postCompaniesStr;
